export const toPriceString = (priceInPence) => {
  const price = priceInPence / 100
  return Number.isInteger(price) ? `£${price}` : `£${price.toFixed(2)}`
}
